#import "../../../../../core-entity/graphql/fragments/tag-fragment.graphql"

fragment ContactInfoFragment on Contact {
    id
    owner {
        id
    }
    territory {
        id
    }
    tags {
        ...TagFragment
    }
    tagMaps(first: 1000) {
        totalCount
        edges {
            creator {
                id
                name
            }
            createdTime
            node {
                ...TagFragment
            }
        }
    }
}
